type AudioContextWindow = Window & {
  webkitAudioContext?: typeof AudioContext;
};

/** Web Audio's context class, under whichever name this browser gives it. */
export const audioContextClass = (): typeof AudioContext | undefined =>
  window.AudioContext ?? (window as AudioContextWindow).webkitAudioContext;
